// Estatus de empleado para presentación: UNA sola resolución compartida por
// Desktop (Expediente: header + Información rápida) y Mobile (listado y
// credencial), para que ningún lugar pueda discrepar.
// Prioridad de la fuente: detalle.estatus (mismo dato que usa Acciones) ->
// empleado.estatus (flujo de Bajas) -> empleado.Estatus (forma real de
// api/empleados, con mayúscula). Solo presentación: no interviene en
// ninguna lógica de negocio.
// Extraído sin cambios desde src/components/Empleados.jsx (M.2A).
export const ESTATUS_EMPLEADO_CONOCIDOS = {
  Activo: { texto: 'Activo', tipo: 'activo' },
  Baja_A_Operativa: { texto: 'Baja A', tipo: 'baja' },
  Baja_B_Sistema: { texto: 'Baja B', tipo: 'baja' },
  Baja_C_IMSS: { texto: 'Baja C', tipo: 'baja' }
};

export function resolverEstatusEmpleado(detalle, empleado) {
  const candidatos = [detalle?.estatus, empleado?.estatus, empleado?.Estatus];
  const valor = candidatos.map(v => (v == null ? '' : String(v).trim())).find(v => v !== '') || '';
  if (!valor) return { valor: '', texto: '—', tipo: 'neutro' };
  const conocido = ESTATUS_EMPLEADO_CONOCIDOS[valor];
  if (conocido) return { valor, ...conocido };
  return { valor, texto: valor.replace(/_/g, ' '), tipo: 'neutro' };
}
